import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { endpoints } from '../../../../environments/environment';
import { BaseResult } from '../../../shared/models/base.result.model';
import { Sacado } from '../models/sacado.model';
import { Endereco } from './models/endereco.model';
import { Estado } from './models/estado';

@Injectable()
export class CepService {
	private url = endpoints.utils;


	constructor(private http: HttpClient) { }

	enderecosPorQuery(cidade: string, uf: string, logradouro: string, bairro: string): Observable<BaseResult<Endereco[]>> {
		return this.http.get<BaseResult<Endereco[]>>(`${this.url.address}?cidade=${cidade}&uf=${uf}&logradouro=${logradouro}` + (bairro ? `&bairro=${bairro}` : ''));
	}

	enderecosPorCep(cep: string): Observable<BaseResult<any[]>> {
		return this.http.get<BaseResult<any[]>>(`${this.url.address}/${cep}/`);
	}

	cidadesPorUf(uf: string): Observable<BaseResult<any>> {
		return this.http.get<BaseResult<any>>(`${this.url.address}/cidades/${uf}/`);
	}

	estados(): Observable<BaseResult<Estado[]>> {
		return this.http.get<BaseResult<Estado[]>>(`${this.url.states}`);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/modal-cep/cep.service.ts